
import axiosInstance from './axiosInstance';

const initialState = {};
 
function rootReducer(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN':
      return { 
        ...state,
        isLoggedIn: true,
        roles: action.payload.roles || [],
        modules: action.payload.modules || [],
        features: action.payload.features || {},
        organization: action.payload.organization,
        username: action.payload.name || '',
        userId: action.payload.id || '',
        is_provider: action.payload.is_provider || false,
        organization_id: action.payload.organization_id,
        isLoading: false,
      };
    case 'LOGOUT':
      return { ...state,
        isLoggedIn: false,
        username: '',
        roles: [],
        modules: [],
        features: {},
        organization: [],
        isLoading: false,
      };
    case 'LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_PENDING_COUNT':
      return { ...state, pendingCount: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
